import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipLabel from "./ElementTooltipLabel";

const _limit = 20;

function TooltipLabel({ node, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  const _label = nodeUtils.getLabel(node);

  if (!_label) {
    return null;
  }

  if (_label.length < _limit) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipLabel node={node} />
    </DefaultTooltip>
  );
}

export default TooltipLabel;
